// extracted by mini-css-extract-plugin
module.exports = {"card_wrapper":"conversion-effect-card_card_wrapper___ScsM","card_title":"conversion-effect-card_card_title__C46B4"};